import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTE_SEO, SITE_TITLE } from '../seo/config';

const PageIntro = ({ title, description }) => {
    const location = useLocation();
    const { t } = useTranslation();
    const routeMeta = ROUTE_SEO[location.pathname];
    const heading =
        title ||
        (routeMeta?.ns ? t(`${routeMeta.ns}:pageTitle`, { defaultValue: '' }) : '') ||
        (location.pathname === '/' ? SITE_TITLE : '');

    return (
        <section className="w-full bg-white dark:bg-gray-800 shadow-lg p-6 rounded-lg border border-gray-200 dark:border-gray-700">
            {heading ? (
                <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">{heading}</h1>
            ) : null}
            <p
                className="first-letter:text-5xl first-letter:font-serif first-letter:mr-3 first-letter:float-left 
                    text-gray-800 dark:text-gray-200 leading-relaxed text-lg font-light drop-cap-style columns-3 sm:columns-2 xs:columns-1"
            >
                {description}
            </p>
        </section>
    );
};

export default PageIntro;
